export interface IsLoadingLazyProps {
    isLazy?: boolean
    index?: number
    currentSlide?: number
}

export interface DataLayerProps {
    sortKey?: string
    componentId?: string
    isBannerTileWithText?: boolean
    subTitle?: string
}

export enum LocationType {
    LandingPage = 'landing_page',
    HomePage = 'home_page',
}
